import React, { useEffect, useState } from "react";
import GlobalDialog from "../../../../mui/Dialogue/GlobalDialog";
import { Box, Button } from "@mui/material";
import ProfileHeader from "./ProfileHeader";
import StudentEditForm from "./StudentEditForm";
import { useDispatch, useSelector } from "react-redux";
import { getLeadEditData } from "../../../../../redux/features/ogdSlice";
import Loader3D from "../../../../Loader/Loader3D";
import { Icon } from "@iconify/react";

const StudentEdit = ({ rowData, croedit }) => {
  const { loading } = useSelector((state) => state.ogd);
  const [open, setOpen] = useState(false);
  const [pending, setPending] = useState(true);
  const dispatch = useDispatch();
  const profile = JSON.parse(localStorage.getItem("cred")).profile;

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        setPending(false);
        dispatch(
          getLeadEditData(croedit ? rowData.admnNo : rowData.admissionNo)
        );
      }, 100);
    } else {
      setPending(true);
    }
  }, [open]);

  return (
    <GlobalDialog
      title={"Edit Student"}
      open={open}
      setOpen={setOpen}
      fullScreen
      popupButton={
        <Button
          sx={{
            background: "linear-gradient(to right, #a125c2, #000000)",
            color: "white",
            borderRadius: 2,
          }}
          onClick={() => setOpen(true)}
        >
          <Icon icon="radix-icons:update" width="20" height="20" />
          {profile
            ? profile.role == "Operations Growth Associate" &&
              profile.roleID == 18
              ? "View Details"
              : "Student update"
            : ""}
        </Button>
      }
      closeButton={true}
      content={
        <>
          {open ? (
            <Box>
              {loading ? (
                <Loader3D />
              ) : (
                <>
                  <Box>
                    <ProfileHeader />
                  </Box>
                  <Box>{pending ? null : <StudentEditForm open={open} />}</Box>
                </>
              )}
            </Box>
          ) : null}
        </>
      }
    />
  );
};

export default StudentEdit;
